import { identify, makeRequest, Service } from 'utils/http';

export async function adminGetAllWorkspacesApi() {
  // TODO: Add legit pagination
  return makeRequest(Service.adminGetAllWorkspaces(99999, 0, await identify()));
}
